import { SVGProps } from "react";

export function StepCompleted({
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="2" width="18" height="18" rx="9" fill="#008934" />
      <g clip-path="url(#clip0_22993_168544)">
        <path d="M7.49067 13.2798L5.20609 10.9952L4.2251 11.9762L7.49067 15.2418L14.2251 8.50736L13.2441 7.52637L7.49067 13.2798Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_22993_168544">
          <rect width="10.8" height="10.8" fill="white" transform="translate(3.6001 5.6001)" />
        </clipPath>
      </defs>
    </svg>
  );
}
